import { render, staticRenderFns } from "./remarkPopup.vue?vue&type=template&id=1260e1e5&scoped=true"
import script from "./remarkPopup.vue?vue&type=script&lang=js"
export * from "./remarkPopup.vue?vue&type=script&lang=js"
import style0 from "./remarkPopup.vue?vue&type=style&index=0&id=1260e1e5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1260e1e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1260e1e5')) {
      api.createRecord('1260e1e5', component.options)
    } else {
      api.reload('1260e1e5', component.options)
    }
    module.hot.accept("./remarkPopup.vue?vue&type=template&id=1260e1e5&scoped=true", function () {
      api.rerender('1260e1e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/remarkPopup.vue"
export default component.exports